import { gql } from '@apollo/client/core'
  
const summaryReturnedFields = `
        username
        isActive
        department { path }
        company { path}
        organisation { path}
        _id
`
/**
 * SUMMARY QUERY
 * Fetches lightweight info for list view
 */
export const SUMMARY_QUERY = gql`
  query UserSummary {
    items: usersByFields {
       ${summaryReturnedFields}
    }
  }
`
const returnedFields = `
      username
      password
      email
      isActive
      timeCreated
      createdBy
      lastAccess
      _id
      organisation {
          name
          path
          iden
          isActive
          createdBy
          timeCreated
          logo
          archived
          _id
      }
      company {
          path
          iden
          name
          organisation {
            _id
            path
          }
          archived
          msAllowSSO
          msTenantID
          msCompanyAdminGroupID
          isActive
          createdBy
          timeCreated
          logo
          primaryColour
          secondaryColour
          _id
      }
      department {
          name
          iden
          path
          company {
             _id
            path
          }
          organisation {
             _id
            path
          }
          archived
          msSupervisorGroupID
          msUserGroupID
          timeCreated
          isActive
          createdBy
          invoiceCode
          _id
      }
      name {
          full
          first
          middle
          last
      }
      roles {
            subsystemAccess
            accessLevel
            entityType
            entityId
            priority
            entityPath
        }
      microsoft {
          scopes
          account_id
          msSSOUniqueId
      }  
      subsystemAccess      
      groups
      accessLevel
  `
/**
 * DETAIL QUERY
 * Fetches full info for editing
 */
export const DETAIL_QUERY = gql`
  query GetUser ($id: MongoID!) {
    item: userById(_id: $id) {
    ${returnedFields}
    }
  }
`

/**
 * CREATE MUTATION
 */
export const CREATE_MUTATION = gql`
  mutation UserCreateOne($record: CreateOneUserInput!) { 
    saveItem: userCreateOne(record: $record) { 
      recordId
      record {    
        ${summaryReturnedFields}
      }  
    } }`

/**
 * UPDATE MUTATION
 * Note: The returned fields should only include those managed by the user privilege.
 * Some fields such as Path, iden, should not be editable by user admins and thus are not returned here to avoid confusion.
 */
export const UPDATE_MUTATION = gql`
  mutation UpdateUser($filter: FilterUpdateOneUserInput, $record: UpdateOneUserInput!) {
    saveItem: userUpdateOne(filter: $filter, record: $record) {
        recordId
        record { ${returnedFields} }
    }
  }
`

/**
 * DELETE MUTATION
 */
export const DELETE_MUTATION = gql`
  mutation RemoveUsers($id: MongoID!) {
    userRemoveById(_id: $id){
    recordId
    }
  }
`
